import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { cx } from '@elliemae/ds-utilities/utils';
import DSSeparator from '@elliemae/ds-basic/Separator';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { dataGridBlockName } from '../../blockNames.js';

var blockName = "".concat(dataGridBlockName, "-expanded-row");
var DetailsWrapper = aggregatedClasses('div')("".concat(blockName, "-details-wrapper"), null, function () {
  return {
    'ie-flex-basis-auto': true
  };
});

function ExpandedRowExtra(_ref) {
  var children = _ref.children,
      rowData = _ref.rowData,
      rowProps = _ref.rowProps,
      RowComponent = _ref.rowComponent,
      _ref$renderRowDetails = _ref.renderRowDetails,
      renderRowDetails = _ref$renderRowDetails === void 0 ? function () {
    return null;
  } : _ref$renderRowDetails;
  return /*#__PURE__*/React.createElement(RowComponent, _extends({}, rowProps, {
    className: cx(rowProps.className, 'expanded-detail-row')
  }), /*#__PURE__*/React.createElement(RowComponent, {
    className: "master-row-expanded"
  }, children), /*#__PURE__*/React.createElement(DSSeparator, {
    dashed: true,
    margin: "xs"
  }), /*#__PURE__*/React.createElement(DetailsWrapper, null, renderRowDetails({
    rowData: rowData
  })));
}

export default ExpandedRowExtra;
//# sourceMappingURL=ExpandedRowExtra.js.map
